import {
  Home,
  ReceiptOutlined,
  SettingsSuggestOutlined,
} from "@mui/icons-material";
import TableChartIcon from "@mui/icons-material/TableChart";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BarChartIcon from "@mui/icons-material/BarChart";
import moment from "moment";

// const drawerItdems = [
//   { name: "Home", icon: <Home />, link: "/" },
//   { name: "Insurance Table", icon: <TableChartIcon />, link: "/insurance" },
//   {
//     name: "Manage User and Targets",
//     icon: <AssignmentIcon />,
//     link: "/manageUsers",
//   },
// ];

// const adminDrawerItems = [
//   { name: "Dealerships", icon: <ReceiptOutlined />, link: "/" },
//   {
//     name: "Transaction History",
//     icon: <SettingsSuggestOutlined />,
//     link: "/transactions",
//   },
// ];

const testlog = () => {
  console.log("test log");
};

const drawerItems = (loggedInAs) => {
  if (loggedInAs === "admin") {
    return [
      { name: "Dealerships", icon: <ReceiptOutlined />, link: "/" },
      {
        name: "Transaction History",
        icon: <SettingsSuggestOutlined />,
        link: "/transactions",
      },
    ];
  } else if (loggedInAs === "manager") {
    // Managers get the full menu, including user/target management.
    return [
      { name: "Home", icon: <Home />, link: "/" },
      { name: "Insurance Table", icon: <TableChartIcon />, link: "/insurance" },
      {
        name: "Manage User and Targets",
        icon: <AssignmentIcon />,
        link: "/manageUsers",
      },
      {
        name: "Reports",
        icon: <BarChartIcon />,
        link: "/reports",
      },
    ];
  } else if (loggedInAs === "employee") {
    // Employees get Home and Reports only — no Insurance Table and no
    // user/target management, both of which are manager-only.
    return [
      { name: "Home", icon: <Home />, link: "/" },
      {
        name: "Reports",
        icon: <BarChartIcon />,
        link: "/reports",
      },
    ];
  } else {
    // Unrecognized/undefined role: fail safe with an empty menu rather
    // than silently granting the full manager/employee menu.
    return [];
  }
};

const lottieLoopOptions = {
  loop: true,
  autoplay: true,
  animationData: null,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const closeWindow = () => {
  // localStorage.clear();
  window.close();
  let win = window.open("", "_self");
  win.close();
};

const appUrl = process.env.REACT_APP_STAGE
  ? process.env.REACT_APP_STAGE === "prod"
    ? `https://app.echeckinsurance.com`
    : `https://${process.env.REACT_APP_STAGE}-app.echeckinsurance.com`
  : "http://localhost:3000";
// "https://leery-joaquin-uninherited.ngrok-free.dev";

const teamID = process.env.TEAM_ID ? process.env.TEAM_ID : "dealer-line";

const capitalizeFirstLetter = (str) => {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1);
  return "";
};

const formatDate = (date) => moment.utc(date).format("MM/DD/YYYY");
const formatDateWithTime = (date) => moment(date).format("MM/DD/YYYY HH:mm:ss");

const today = moment(new Date()).format("YYYY/MM/DD");
const firstOfMonth = moment(
  new Date(new Date().getFullYear(), new Date().getMonth(), 1),
).format("YYYY/MM/DD");

const formatMonth = (date) => moment.utc(date).format("MMMM");

const roundOf = (decimal) => Math.round(decimal);

const TYPE = {
  QR: "qr-code",
  VERIFY: "verify-insurance",
  API_LOG: "api-log",
  DOCUMENT: "document",
  ADD_USER: "add-user",
  UPDATE_USER: "update-user",
  YMM: "ymm",
  PRIVACY_POLICY: "privacy-policy",
  USER_TERMS: "user-terms",
  CUSTOMER_INFO: "customer-info",
  PULL_DETAILS: " pull-details",
  EDIT_DEALERSHIP: "edit-dealership",
  UPDATE_SUBSCRIPTION: "update-subscription",
  CREATE_DEALERSHIP: "create-dealership",
  EMAIL_BILLING: "email-billing",
  OUTPUT_PAYLOAD: "output-payload",
  CANOPY_ERROR: "Canopy-Error",
  DEFAULT: "default",
  UPDATE_USER: "update-user",
  CREATE_USER: "Create User",
  LOG_OUT: "log_out",
  DEACTIVATE_DEALER: "dealership_status",
  PROMOTE_EMPLOYEE: "promote_employee",
  DEACTIVATE_USER: "deactivate_user",
  IMPORT_USERS: "import-users",
  QUOTE_QUESTIONS: "questionnaires",
  CUSTOMER_DETAILS: "customer_details",
  LOGOUT: "logout",
  UPLOAD_LOGO: "Upload Logo",
  REPULL_DETAILS: "Repull Insurance",
  SERVICES: "Services",
  ARTIFACTS: "Artifacts",
  ACCESS_DENIED: "Access Denied",
  KNOWLEDGE_HUB: "Knowledge Hub",
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const userTemplateURL =
  "https://s3.us-east-2.amazonaws.com/echeck.prod/app/template/import-users.xlsx";

const formatToDate = (str) => moment(str, "YYYY-MM-DDTHH:mm:ss.000").toDate();
const formatToDateOnly = (str) => moment(str).format("MM/DD/YYYY");
const formatToTimeOnly = (str) => moment(str).format("hh:mm A");

const generateRandomId = (length) => {
  let result = "";
  const characters = "0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result;
};

const ensureAbsoluteUrl = (url) => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};
const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const menuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
    },
  },
};
const isValidInput = (input) => {
  const trimmedInput = input.trim();
  if (trimmedInput === "") return true;
  const regex = /^[a-zA-Z]$/;
  return !regex.test(trimmedInput) || trimmedInput.split(/\s+/).length > 1;
};

const options = ["English", "Spanish"];

const formatTime = (secs) => {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = secs % 60;

  const formatUnit = (unit) => unit.toString().padStart(2, "0");

  return `${formatUnit(hours)}.${formatUnit(minutes)}.${formatUnit(seconds)}`;
};
const timeConversion = (customer) => {
  const time = customer?.appointmentResponse?.time;
  if (!time || typeof time !== "string" || !time.includes(":")) {
    return time ?? "";
  }
  const [hour, minutes] = time.split(":");
  const hourInt = parseInt(hour, 10);
  if (Number.isNaN(hourInt)) {
    return time;
  }
  const suffix = hourInt >= 9 && hourInt < 12 ? "AM" : "PM";
  return `${time} `;
};

const getVIN = (vehicles, status) => {
  const vehicle = vehicles.find(
    (vehicle) => vehicle.vehicle_status_id === status,
  );

  if (vehicle) {
    if (vehicle.vin) {
      return vehicle.vin;
    } else {
      return "N/A";
    }
  } else {
    return "N/A";
  }
};
const getVehicleDetail = (vehicles, status) => {
  const vehicle = vehicles.find(
    (vehicle) => vehicle.vehicle_status_id === status,
  );

  if (vehicle) {
    if (vehicle.year || vehicle.make || vehicle.model) {
      return vehicle.year + " " + vehicle.make + " " + vehicle.model;
    } else {
      return "N/A";
    }
  } else {
    return "N/A";
  }
};

const getOption = (questions, index) => {
  const optionArrays = questions.map((question) => question.options);
  if (index >= 0 && index < optionArrays.length) {
    return optionArrays[index];
  } else {
    return "N/A";
  }
};

const formattedWithDollar = (str) => {
  const cents = str;
  const dollars = cents / 100;

  const formatted = dollars.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatted;
};
const formatCurrency = (cents) => {
  const dollar = cents / 100;
  if (dollar % 1 === 0) {
    return Math.floor(dollar).toString();
  } else {
    if (dollar.toFixed(1) % 1 === 0)
      return Math.floor(dollar.toFixed(1)).toString();
    else return dollar.toFixed(1);
  }
};
const getEmbedUrl = (videoUrl) => {
  if (!videoUrl) return null;
  const url = new URL(videoUrl);

  const isYouTubeDomain = (hostname) =>
    hostname === "www.youtube.com" || hostname === "youtube.com";

  if (isYouTubeDomain(url.hostname) && url.searchParams.get("v")) {
    return `https://www.youtube.com/embed/${url.searchParams.get(
      "v",
    )}?playsinline=1`;
  } else if (url.hostname === "youtu.be") {
    return `https://www.youtube.com/embed/${url.pathname.slice(
      1,
    )}?playsinline=1`;
  } else if (
    isYouTubeDomain(url.hostname) &&
    url.pathname.startsWith("/shorts")
  ) {
    const videoId = url.pathname.split("/")[2];
    return `https://www.youtube.com/embed/${videoId}?playsinline=1`;
  } else if (url.hostname === "vimeo.com") {
    // Extract Vimeo video ID from the pathname
    const videoId = url.pathname.split("/")[1];
    return `https://player.vimeo.com/video/${videoId}`;
  }

  return videoUrl;
};
export {
  drawerItems,
  lottieLoopOptions,
  closeWindow,
  appUrl,
  capitalizeFirstLetter,
  formatDate,
  formatDateWithTime,
  formatMonth,
  teamID,
  TYPE,
  roundOf,
  delay,
  today,
  firstOfMonth,
  userTemplateURL,
  formatToDate,
  generateRandomId,
  ensureAbsoluteUrl,
  weekDays,
  menuProps,
  isValidInput,
  options,
  formatTime,
  timeConversion,
  getVIN,
  getVehicleDetail,
  getOption,
  formatToDateOnly,
  formattedWithDollar,
  formatCurrency,
  formatToTimeOnly,
  getEmbedUrl,
  testlog,
};